export default {
    clipboard: {
        add  : {
            tooltip: "Bearbeitungsschritt ins Clipboard stellen",
            query  : "Daten ins Clipboard übernehmen?",
            text   : "Mit JA werden die Daten der Anlage aus der Ereignismappe in das Clipboard übernommen. Diese Daten können später aus dem Clipboard wieder in eine andere Ereignismappe übernommen werden.",
            success: "Der Bearbeitungsschritt wurde in das Clipboard übernommen",
        },

        remove: {
            tooltip: "Bearbeitungsschritt im Clipboard wieder freigeben",
            query  : "Daten im Clipboard freigeben?",
            text   : "Mit JA werden die Daten der Anlage aus der Ereignismappe aus dem Clipboard gelöscht. Anschließend können die Daten aus dem Clipboard wieder in der Ereignismappe bearbeitet werden.",
            success: "Der Bearbeitungsschritt wurde aus dem Clipboard entfernt",
        },

        show: {
            tooltip: "Anzeigen"
        },

        paste: {
            success : "Die Daten aus dem Clipboard wurden übernommen",
            unitexists: {
                query: "<span style='color:red'>Konflikte bei der Datenübernahme</span>",
                text : "<b style='font-size: larger'>Anlage:</b><br>In der Ereignismappe sind bereits Daten für die Anlage <b>{0}</b> vorhanden. Mit <b>JA</b> werden diese Daten überschrieben."
            },
            manufacturer: {
                query: "<span style='color:red'>Konflikte bei der Datenübernahme</span>",
                text : "<b style='font-size: larger'>Ausführende Unternehmen:</b><br>Für die folgenden Bearbeitungschritte unterscheiden sich die ausführenden Unternehmen:<br><br>{0}<br>Mit <b>JA</b> werden die ausführenden Unternehmen aus dem Clipboard <b>nicht</b> übernommen."
            },
            unitexistsmanufacturer: {
                query: "<span style='color:red'>Konflikte bei der Datenübernahme</span>",
                text : "<b style='font-size: larger'>Anlage:</b><br>In der Ereignismappe sind bereits Daten für die Anlage <b>{0}</b> vorhanden. Mit <b>JA</b> werden diese Daten überschrieben.<br><br><b style='font-size: larger'>Ausführende Unternehmen:</b><br>Für die folgenden Bearbeitunschritte unterscheiden sich die ausführenden Unternehmen:<br><br>{1}<br>Mit <b>JA</b> werden die ausführenden Unternehmen aus dem Clipboard <b>nicht</b> übernommen."
            },
        },

        entrynotfound: {
            title: "Eintrag nicht (mehr) vorhanden",
            message: "Der Eintrag im Clipboard wurde bereits verarbeitet."
        },

        drop: {
            incident: {
                same: "Das Ereignis aus dem Clipboard entspricht dem Ereignis das bearbeitet wird.",
                type: "Die Ereignisart aus dem Clipboard passt nicht zum dem Ereignis das bearbeitet wird.",
                unit: "Das Ereignis kann nicht mit dem Ereignis aus dem Clipboard überschrieben werden (gleiche Anlage).",
                notallowed: "Der Clipboard Eintrag kann hier nicht eingefügt werden."
            }
        }
    },
}